export default {
	offset: ['$stateParams', '$state', function ($stateParams,$state) {
		return  $stateParams.offset || 0;
	}]
};



// WEBPACK FOOTER //
// ./src/page/receiptsDetails/receiptsDetails.resolve.js